import Theme from '@adsk/alloy-react-theme';

export const buttonStyle = {
  height: '25px',
  marginLeft: '11px',
  minWidth: '128px',
  ...Theme.typography.ellipsis,
  ...Theme.typography.labelSmall,
};

export const containerStyle = {
  display: 'flex',
  'flex-direction': 'row',
};

export const messageStyle = (daysLeft: number | null) => ({
  display: 'flex',
  alignItems: 'center',
  color:
    daysLeft !== null && daysLeft <= 3
      ? Theme.colors.red500
      : Theme.colors.charcoal900,
  ...Theme.typography.bodyMedium,
  ...Theme.typography.ellipsis,
  [Theme.mediaQuery.medium]: {
    display: 'none',
  },
});
